import DashboardWelcome from "components/PortalDashboard";
import Admin2 from "layouts/Admin2";
import Aggregates from "./Aggregates";
import SubscriptionSeatsCard from "./SubscriptionSeatsCard";

const InstitutionDashboard = () => {
	return (
		<Admin2>
			<div className="portal-dashboard">
                <DashboardWelcome variant="institution" />
				<Aggregates />
				<SubscriptionSeatsCard />
			</div>
		</Admin2>
	);
};

export default InstitutionDashboard;
